import BoltBanner from "../boltClone/BoltBanner";
import BoltOwnCode from "../boltClone/BoltOwnCode";
import { lazy, Suspense } from "react";

const LyftTeamlogo = lazy(() => import("../LyftClone/LyftTeamlogo"));
const BoltSuperlative = lazy(() => import("../boltClone/BoltSuperlative"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltBuild = lazy(() => import("../boltClone/BoltBuild"));
const BoltForYou = lazy(() => import("../boltClone/BoltForYou"));
const BoltDevelopement = lazy(() => import("../boltClone/BoltDevelopement"));
const BoltCustom = lazy(() => import("../boltClone/BoltCustom"));
const BoltSmart = lazy(() => import("../boltClone/BoltSmart"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGen = lazy(() => import("../boltClone/BoltGen"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));

const bannerData = {
  class: "bolt-banner",
  titlePart1: "Yellow Cab Clone App",
  titlePart2: "Development Company",
  description: "Canada’s top-tier specialists in building secure, scalable, and fully customizable taxi booking applications tailored for seamless rider and driver experiences.",
  image: "/assets/home/bolt-banner.webp",
  btn1: "contact us",
  btn2: "watch demo",
  counter1: {
    number: "2000+",
    text: "Apps Launched"
  },
  counter2: {
    number: "100+",
    text: "Expert Developers"
  },
  counter3: {
    number: "250+",
    text: "Happy Clients"
  },
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "Yellow cab Clone App",
        slug: ""
      },
    ]
  }
};

const OwnCodeData = {
  box1: {
    image: "/assets/home/bolt-own-code-1.webp",
    title: "Own the Entire Source Code",
  },
  box2: {
    image: "/assets/home/bolt-own-code-2.webp",
    title: "Outstanding UI & Superior UX",
  },
  box3: {
    image: "/assets/home/bolt-own-code-3.webp",
    title: "Fully Customized Solution",
  },
  box4: {
    image: "/assets/home/bolt-own-code-4.webp",
    title: "Next-Level Features",
  },
}

const superlativeData = {
  titlePart1: "Why",
  titlePart2: "Yellow Cab Clone App",
  titlePart3: "Is Ultimate Solution for Taxi Businesses in Canada?",
  description1: "As urban centres across Canada—from the snow-covered streets of Winnipeg to the bustling avenues of Toronto—demand more reliable, efficient, and user-friendly transportation options, Mobility Infotech presents the Yellow Cab Clone App as the modern solution built for Canadian realities. Inspired by the simplicity and dependability of legacy services like Yellow Cab, our ride-hailing platform is designed to offer flexibility, high performance, and complete localization. Whether you're launching a new taxi startup in Montreal, managing a fleet in Calgary, or scaling your services across British Columbia, our Yellow Cab Clone App provides a comprehensive and future-proof digital infrastructure. Core features such as real-time ride-matching, driver GPS tracking, live fare calculation, secure in-app transactions, and live trip updates ensure that both passengers and drivers enjoy seamless connectivity, even during peak hours or severe weather conditions.",
  description2: "What truly distinguishes our clone app is not just its intuitive design or reliable backend—it’s the strategic advantage it delivers. With region-specific geo-fencing, surge pricing functionality, support for bilingual and multilingual users (English, French, Punjabi, and more), promotional campaign tools, and full white-label capabilities, this app is built to thrive in Canada’s multicultural and geographically diverse transportation ecosystem. Built with scalability in mind, the Yellow Cab Clone App grows with your business, supporting your expansion from a single city operation to a cross-province or nationwide presence without sacrificing speed or stability. In today’s fast-evolving mobility market, having the right tech foundation isn’t optional—it’s essential. Choose Mobility Infotech’s Yellow Cab Clone App – the smarter, more powerful, and fully adaptable platform to drive your taxi business forward in Canada.",
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Powering Canada’s transportation evolution—one ride at a time.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch dynamic, real-time taxi booking services with instant ride-matching, GPS-enabled tracking, and secure in-app payment systems. Ideal for startups and local operators seeking to bring Yellow Cab-style convenience to cities across Canada—from Halifax to Edmonton.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Encourage eco-conscious and cost-effective commuting with intelligent ride-sharing technology. Our app facilitates smart rider-driver matching, fare splitting, and optimized routing—perfect for Canada’s dense urban centres and sustainability-minded travellers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Streamline employee transportation with robust corporate-grade solutions. With tools like automated invoicing, detailed ride logs, admin controls, and travel policies, this option is tailor-made for Canadian enterprises and business mobility teams.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Enable users to book Yellow Cab-style rides by the hour or for intercity travel on-demand. A versatile choice for tourists, event attendees, and professionals needing reliable transport in cities like Montreal, Ottawa, or Vancouver.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Cater to Canada’s premium travellers with sophisticated limo and high-end taxi services. Offer exclusive features like professional chauffeur tracking, premium vehicle selection, and white-glove service—ideal for corporate events, VIP transfers, and hospitality providers.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Deliver quick, affordable rides using two-wheeler taxi integration—especially effective for dense traffic zones and last-mile travel in metropolitan hubs like Toronto or Montreal.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Build your own branded taxi service with our white-label Yellow Cab Clone App. Customize everything from your logo to the feature set, UI, and language options (including bilingual French-English support) to stand out in any Canadian region.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Enhance airport commutes with real-time flight tracking, pre-booking capabilities, and driver update automation. An ideal solution for operations near Canada’s busiest airports like Toronto Pearson, Vancouver YVR, and Calgary International.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Champion Canada’s sustainability goals with an EV-optimized taxi app. Includes features like charging station locators, live battery stats, and eco-tracking—perfect for operators embracing a greener fleet.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Promote inclusive mobility with accessibility-compliant features, specially equipped vehicles, and trained drivers. A must-have for community transit services, elderly care providers, and accessibility-focused transportation initiatives across Canada.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with Canada’s ",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace digital innovation with our next-gen Yellow Cab Clone App solutions and take your taxi business to the next level.",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Rise in Customer Loyalty and Repeat Rides",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Every Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch a Yellow Cab-like app? Understanding the customer journey is key. Here's how our Yellow Cab Clone App delivers smooth, secure, and satisfying service:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const buildData = {
  titlePart1: "We Build Taxi Booking Apps",
  titlePart2: "Using Advanced Features",
  description: "At Mobility Infotech, we integrate cutting-edge technologies into your Yellow Cab Clone App to elevate performance, user satisfaction, and operational efficiency across Canadian cities:",
  btn: "more features",
  tabs: [{
    title: "AI-Powered Route Optimization",
    description: "AI dynamically finds the fastest and most fuel-efficient routes—essential for reducing travel time and operating costs in cities like Vancouver, Toronto, and Montreal.",
    icon: "/assets/home/bolt-build-icon-1.webp",
    image: "/assets/home/bolt-build-1.webp",
  },
  {
    title: "IoT for Vehicle Tracking",
    description: "IoT tech enables real-time fleet tracking, predictive maintenance alerts, and safety analytics. Gain better control over vehicles and keep riders informed every step of the way.",
    icon: "/assets/home/bolt-build-icon-2.webp",
    image: "/assets/home/bolt-build-2.webp",
  },
  {
    title: "Chatbots for Customer Support",
    description: "Offer round-the-clock support with AI chatbots that manage bookings, cancellations, FAQs, and more—reducing workload and improving user experience across Canada’s multilingual population.",
    icon: "/assets/home/bolt-build-icon-3.webp",
    image: "/assets/home/bolt-build-3.webp",
  },
  {
    title: "Blockchain for Secure Payments",
    description: "Blockchain integration ensures secure, tamper-proof transactions, boosting transparency for both drivers and passengers while eliminating fraud and payment disputes.",
    icon: "/assets/home/bolt-build-icon-4.webp",
    image: "/assets/home/bolt-build-4.webp",
  },
  {
    title: "Intelligent Driver Matching System",
    description: "Our smart algorithm matches riders with the most suitable drivers based on proximity, ride preferences, and driver ratings—minimizing wait times and enhancing service quality.",
    icon: "/assets/home/bolt-build-icon-5.webp",
    image: "/assets/home/bolt-build-5.webp",
  },
  {
    title: "AR for Enhanced Navigation",
    description: "Augmented Reality helps drivers navigate complex cityscapes by overlaying digital cues on real-world visuals—particularly helpful in congested or unfamiliar routes.",
    icon: "/assets/home/bolt-build-icon-6.webp",
    image: "/assets/home/bolt-build-6.webp",
  },],
}

const forYouData = {
  newClass: "bolt-for-you",
  text: "Mobility Infotech Will",
  text2: "Build a White-Label Taxi Booking",
  title: "App Just for You",
  btn: "BEGIN NOW!",
}

const developementData = {
  titlePart1: "Core Modules That ",
  titlePart2: "Power Your Taxi ",
  titlePart3: "Ecosystem",
  description: "Built by Mobility Infotech for the Canadian market, our Yellow Cab Clone App combines reliability, scalability, and smart mobility solutions to elevate your taxi business.",
  btn: "Get Started",
  customer: {
    image: "/assets/home/bolt-developement-1.webp",
    title: "Customer App",
    description: "Make riding intuitive and delightful with these user-centric features:",
    boxes: [
      {
        title: "Seamless Ride Booking",
        desc: "Book rides effortlessly with a user-friendly interface optimized for Canadian cities, ensuring quick, intuitive, and hassle-free ride scheduling."
      },
      {
        title: "Flexible Payment Options",
        desc: "Multiple secure payment options including credit/debit cards, Apple Pay, Google Pay, Interac, or cash for maximum user convenience."
      },
      {
        title: "Live Trip Sharing",
        desc: "Share your real-time ride status with family or friends to ensure added safety and transparency during every trip."
      },
      {
        title: "Schedule Rides in Advance",
        desc: "Book your ride ahead of time for airport transfers, intercity travel, or early morning commutes with guaranteed punctuality."
      },
      {
        title: "Live Driver Tracking",
        desc: "Track driver movement in real time on a live map with ETA updates and instant alerts for pickup visibility."
      },
      {
        title: "Push Notifications",
        desc: "Receive instant updates on ride status, promotions, driver details, arrival times, and service announcements in real-time."
      },
    ]
  },
  driver: {
    image: "/assets/home/bolt-developement-2.webp",
    title: "Driver App",
    description: "Designed to help drivers earn more and stress less:",
    boxes: [
      {
        title: "Direct Passenger Calling",
        desc: "Call passengers directly through the app for smoother pickup coordination without revealing personal contact information."
      },
      {
        title: "Real-Time Optimized Navigation",
        desc: "Get AI-powered route suggestions with traffic updates to ensure the fastest and most efficient route every time."
      },
      {
        title: "Start & End Ride Tracking",
        desc: "Start or end rides with a tap, ensuring accurate trip timing, logging, and automatic fare calculation."
      },
      {
        title: "Built-In Help & Support",
        desc: "Access instant help within the app for route assistance, fare issues, or app usage queries."
      },
      {
        title: "Earnings Dashboard",
        desc: "Track daily income, ride summaries, and detailed earning reports to stay informed and motivated."
      },
      {
        title: "In-App Chat",
        desc: "Message passengers securely to resolve queries or share updates without leaving the app."
      },
    ]
  },
  dispatcher: {
    image: "/assets/home/bolt-developement-3.webp",
    title: "Dispatcher Dashboard",
    description: "Take control with a powerful dispatch center for seamless fleet and ride management:",
    boxes: [
      {
        title: "Automatic Dispatching",
        desc: "Automatically assign the nearest available driver to incoming bookings for reduced wait times and faster service."
      },
      {
        title: "Booking Management",
        desc: "Manage, track, and edit all bookings in real time for complete operational control and efficiency."
      },
      {
        title: "Live Fleet Tracking",
        desc: "Monitor every vehicle’s location and status live to improve response times and traffic management."
      },
      {
        title: "Push Alerts for Dispatch",
        desc: "Send immediate instructions, alerts, or trip changes to individual drivers or the whole fleet as needed."
      },
      {
        title: "Smart Route Planning to Cut Fuel Costs",
        desc: "Use AI-driven route suggestions to minimize fuel usage and trip durations while maximizing efficiency."
      },
      {
        title: "Complete Ride & Transaction History",
        desc: "Access logs of completed, pending, and cancelled rides with full details on fares, timings, and transactions."
      },
    ]
  },
  admin: {
    image: "/assets/home/bolt-developement-4.webp",
    title: "Admin Panel",
    description: "Oversee operations, analyze performance, and manage growth with ease:",
    boxes: [
      {
        title: "Driver Onboarding & Management",
        desc: "Easily register, approve, assign, or remove drivers based on service areas, ratings, and operational demand."
      },
      {
        title: "Promo Code & Loyalty Program Setup",
        desc: "Create and manage custom offers, discounts, and loyalty points to boost customer retention and attract new users."
      },
      {
        title: "Payment & Settlement Oversight",
        desc: "Securely manage payments, refunds, and settlements with integrated Canadian payment gateways for smooth transactions."
      },
      {
        title: "Real-Time Communication with Drivers/Dispatchers",
        desc: " Chat live with team members to resolve issues, assign tasks, or provide updates on operations."
      },
      {
        title: "Comprehensive Analytics & Business Intelligence",
        desc: "Monitor ride volumes, customer behavior, revenue trends, and operational metrics with intuitive visual dashboards."
      },
      {
        title: "Booking & Revenue Monitoring",
        desc: "Track every ride’s status and related revenue in real-time to optimize business performance and strategy."
      },
    ]
  },
}

const customData = {
  titlePart1: "Serving Diverse Industries",
  titlePart2: "with Custom Taxi App Solutions",
  description: "Whether you're a taxi fleet operator, a travel service provider, or a large enterprise, the Yellow Cab Clone App by Mobility Infotech delivers scalable, secure, and highly customizable taxi booking solutions. Built for Canada’s evolving mobility landscape, our technology enhances customer experience, operational control, and business profitability.",
  slides: [
    {
      image: "/assets/home/bolt-custom-slide-1.webp",
      title: "Corporate Transportation Providers",
      desc: "Simplify event logistics with automated dispatch, guest ride tracking, and smooth route management for efficient, stress-free transport coordination.",
    },
    {
      image: "/assets/home/bolt-custom-slide-2.webp",
      title: "Taxi App for fleet Businesses",
      desc: "Streamline school bus operations with real-time location updates, attendance logs, and timely alerts to parents and staff.",
    },
    {
      image: "/assets/home/bolt-custom-slide-3.webp",
      title: "Events Transportation Providers",
      desc: "Support seamless tour operations with driver tracking, route optimization, and easy customer communication tools for travel operators.",
    },
    {
      image: "/assets/home/bolt-custom-slide-4.webp",
      title: "School And College Operation",
      desc: "Optimize staff transport with secure ride management, trip logs, and shift-based dispatch for improved corporate travel planning.",
    },
    {
      image: "/assets/home/bolt-custom-slide-5.webp",
      title: "Tour & Travel Operation",
      desc: "Control your taxi business with tools for ride dispatch, fleet monitoring, and performance tracking — all in one place.",
    },
  ]
}

const smartData = {
  titlePart1: "Where",
  titlePart2: "Smart Mobility Meets",
  titlePart3: "Profitable App Business Models",
  description: "Our Yellow Cab Clone App goes beyond ride bookings to unlock new revenue streams that power business growth across Canadian cities.",
  boxes: [
    {
      image: "/assets/home/bolt-smart-1.webp",
      title: "Trip Commissions",
      desc: "Earn a commission on every ride completed through your platform, ensuring consistent income.",
    },
    {
      image: "/assets/home/bolt-smart-2.webp",
      title: "Surge Pricing",
      desc: "Apply dynamic pricing during peak hours or local events to maximize revenue without affecting service quality.",
    },
    {
      image: "/assets/home/bolt-smart-3.webp",
      title: "Premium Bookings",
      desc: "Offer luxury vehicles or SUVs at premium rates to attract high-end customers and boost margins.",
    },
    {
      image: "/assets/home/bolt-smart-4.webp",
      title: "Cancellation Fees",
      desc: "Set cancellation policies that allow you to recover costs from last-minute rider cancellations.",
    },
    {
      image: "/assets/home/bolt-smart-5.webp",
      title: "Leasing to Drivers",
      desc: "Provide flexible lease or commission-based options for drivers to join and operate on your platform.",
    },
    {
      image: "/assets/home/bolt-smart-6.webp",
      title: "Brand Advertising",
      desc: "Allow local or national brands to advertise within the app, creating an additional monetization channel.",
    },
  ]
}

const WhiteLabelData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over a decade of industry expertise, we help you launch a fully branded and customized Yellow Cab-style app built to scale across Canada.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Launch your unique taxi brand with a custom logo, colors, and features designed to reflect your identity.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Deploy your full-featured app within 3 days and begin operations immediately.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "From local operations to a nationwide rollout, our architecture supports seamless growth.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Connect effortlessly to Canadian payment gateways, ERP systems, and third-party tools.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Tailor every detail—from interface language (including French) to feature sets—to meet your market demands.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Deliver a smooth and intuitive experience for both riders and drivers in every Canadian province.",
    },
  ]
}

const genData = {
  titlePart1: "Next-Gen",
  titlePart2: "Taxi App Development",
  titlePart3: "Company Driving Innovation",
  description: "Why Canadian businesses choose Mobility Infotech for their Yellow Cab Clone App:",
  boxes: [
    {
      image: "/assets/home/lyft-minimum-1.webp",
      title: "Automate dispatch and driver allocation.",
    },
    {
      image: "/assets/home/lyft-minimum-2.webp",
      title: "Track drivers in real time via GPS.",
    },
    {
      image: "/assets/home/lyft-minimum-3.webp",
      title: "Monitor operations with smart dashboards.",
    },
    {
      image: "/assets/home/lyft-minimum-4.webp",
      title: "Use analytics for data-driven decisions.",
    },
    {
      image: "/assets/home/lyft-minimum-5.webp",
      title: "Accept Interac, Apple Pay, Google Pay, and more.",
    },
    {
      image: "/assets/home/lyft-minimum-6.webp",
      title: "Build trust with ride ratings and feedback.",
    },
  ],
}

const globalData = {
  titlePart1: "Impact That",
  titlePart2: "Our Taxi App Development ",
  titlePart3: "Company Has Created Globally!",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Cost",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is the Yellow Cab Clone App by Mobility Infotech?",
    answer: "The Yellow Cab Clone App is a fully customizable, white-label taxi booking solution built by Mobility Infotech to replicate and enhance the functionality of the traditional Yellow Cab system, tailored specifically for Canada’s mobility landscape.",
  },
  {
    id: "1",
    question: "02. Is the Yellow Cab Clone App compliant with Canadian transport regulations?",
    answer: "Yes. Our solution includes region-specific geo-fencing, tax calculation, bilingual support (English and French), and features that comply with Canadian privacy, accessibility, and transport standards.",
  },
  {
    id: "2",
    question: "03. Can I customize the app’s branding and interface?",
    answer: "Absolutely! The app is fully white-label, allowing you to add your logo, brand colours, feature preferences, language options, and more—making it uniquely yours.",
  },
  {
    id: "3",
    question: "04. How quickly can I launch my Yellow Cab-style taxi app in Canada?",
    answer: "Our ready-to-deploy Yellow Cab Clone App can be launched in as little as 72 hours, depending on the level of customization and integration required.",
  },
  {
    id: "4",
    question: "05. Does the app support bilingual or multilingual features?",
    answer: "Yes. The Yellow Cab Clone App supports multiple languages, including English, French, and Punjabi, ensuring accessibility for Canada's multicultural population.",
  },
  {
    id: "5",
    question: "06. What payment options does the Yellow Cab Clone App support?",
    answer: "The app integrates with popular Canadian payment methods, including Interac e-Transfers, credit/debit cards, Apple Pay, Google Pay, and optional cash handling.",
  },
  {
    id: "6",
    question: "07. Can I offer both scheduled and on-demand ride options?",
    answer: "Yes. Users can book immediate rides or schedule future ones, making it ideal for airport transfers, early morning commutes, or event-based transportation.",
  },
  {
    id: "7",
    question: "08. How does the app ensure passenger safety and trust?",
    answer: "The app includes OTP ride verification, live driver tracking, driver profile visibility, trip sharing features, and an integrated rating system to enhance safety and transparency.",
  },
];

export default function YellowCab() {
  return (
    <>
      <BoltBanner data={bannerData} />
      <BoltOwnCode data={OwnCodeData} />

      <Suspense fallback={null}>
        <LyftTeamlogo heading={true} newClass="bolt-clone-team" />
        <BoltSuperlative data={superlativeData} />
        <BoltNeed data={needData} />
        <BoltDrive data={driveData} />
        <BoltJourney data={journeyData} />
        <BoltBuild data={buildData} />
        <BoltForYou data={forYouData} />
        <BoltDevelopement data={developementData} />
        <BoltCustom data={customData} />
        <BoltSmart data={smartData} />
        <BoltWhiteLabel data={WhiteLabelData} />
        <BoltGen data={genData} />
        <BoltGlobal data={globalData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
